<h2 class="modal-title">Switch Profile</h2>

<div class="modal-body">
  <h2>Customers</h2>
  <p *ngFor="let customer of customers" 
    class="company-select-option"
    [ngClass]="{'currently-selected-company' : customer.customerId == currentlySelectedCompany}"
    (click)=selectCustomer(customer.customerId)>{{customer.customerName}}
  </p>
</div>
<div class="modal-actions">
  <a id="cancel" class="button-primary blueButton-primary-active" (click)="cancel()">Cancel</a>
</div>